Profiling.Models ||= {}

class Profiling.Models.ProfilePreview extends Backbone.Model
  paramRoot: 'social_content'
  SENTIMENTS = [-20, 20, 0]

  defaults:
    edit_tags: false

  groupType: ->
    return @get('group_type')

  subType: ->
    return ''

  newSubType: ->
    @subType()

  privacy: ->
    if @subType() in ['direct-message', 'fb-message', 'email'] then 'private' else 'public'

  numeric_id: ->
    return @get('data').id

  externalId: ->
    # should return the providers content id
    @numeric_id()

  cassandra_id: ->
    return @get('id')

  isRetweet: ->
    false

  isDrillDownMode: ->
    @get('isDrillDownMode')

  isEmail: ->
    @type() == 'email'

  isPrivateMessage: ->
    false

  initialize: (json) ->
    data = json.data
    evidences = json.evidences
    if typeof(data) == 'string'
      data = $.parseJSON(data)
    if typeof(evidences) == 'string'
      evidences = $.parseJSON(evidences)
    @set('data', data)
    @set('evidences', evidences)

  sentiment: ->
    if @getSentiment()
      value = @getSentiment().value
      if value <= -1
        return 'Negative'
      else if value >= 1
        return 'Positive'
      else if value == 0
        return 'Neutral'
      else return ''
    return ''

  _transformSentimentForArray: (sentiment) ->
    return '' unless sentiment
    value = sentiment.value
    if value < 0
      return -20
    else if value > 0
      return 20
    else if value == 0
      return 0
    else
      return ''

  sentimentValue: ->
    return if @getSentiment() then @getSentiment().value else 0

  getSentiment: (value = false) ->
    if @get('data')
      if value
        @get('data').sentiment?.value
      else
        @get('data').sentiment
    else
      undefined

  setSentiment: (value) ->
    sentiment = @getSentiment()
    sentiment ||= {}
    sentiment.value = value
    @get('data').sentiment = sentiment

  created_at_ISO: ->
    date = @created_at()
    if date
      return new Date(date).format()
    else
      return ''

  link_media_url: (link) ->
    "/snapshot/preview?url=#{link}"

  tags: (codes_only = true) ->
    # TODO: check if the optional param is working
    if codes_only
      @get('tags') || []
    else
      _.filter(@possibleTags(), (tag) =>
        _.contains(@get('tags'), tag.code))

  possibleTags: ->
    tags = @get('possibleTags') or []
    _.sortBy(tags, (t) -> t.description.toLowerCase())

  addTags: (codes) ->
    @set('tags', _.uniq(@get('tags').concat(codes)))

  mainTags: ->
    return @possibleTags().filter (tag) =>
       @isMainTag(tag)

  arrayHasTag: (array, tag) ->
    tag = tag || {}
    description = tag.description || ''
    code = tag.code || ''
    _.intersection(array, [tag, tag.description, tag.code]).length > 0

  hasTag: (tag) ->
    @arrayHasTag(@tags(), tag)

  isMainTag: (tag) ->
    @hasTag(tag) or @isHotTag(tag) or @isSuggestedTag(tag)

  isHotTag: (tag) ->
    @canEditTags() and tag.hot_tag

  isSuggestedTag: (tag) ->
    @arrayHasTag(@suggestedTags(), tag)

  negativeTags: ->
    return @possibleTags().filter (tag) =>
      tag.implies_rejection == true && !@isMainTag(tag)

  neutralTags: ->
    return @possibleTags().filter (tag) =>
      tag.implies_rejection == false && !@isMainTag(tag)

  suggestedTags: ->
    return @get('suggested_tags') || []

  unappliedTags: ->
    @neutralTags().concat(@negativeTags()) # does not include suggested tags

  allTagsActAsHot: ->
    false

  isReviewMode: ->
    return @get('review_mode')

  canEditTags: ->
    return (@get('edit_tags') || @isReviewMode())

  labels: ->
    return @get('labels')

  status: ->
    return @get('status')

  status_class: ->
    if @status() == 'APPROVED'
      return 'approved'
    else if @status() == 'REJECTED'
      return 'rejected'
    else if @status() == 'UNKNOWN'
      return 'pending'
    else
      return ''

  id: ->
    return @get('id')

  lastModerator: ->
    return @get('last_moderator')

  legacyId: ->
    return @get('legacy_id')

  getTopicsName: ->
    return _.pluck(@get('topics'), 'name')

  topicAllowsCustomer: ->
    return _.some(@get('topics'), (topic) -> topic.customer_enabled)

  addAnchorsToLinks: (content) ->
    return content.replace(/(?:<em .*?>)?(?:(https?:\/\/[\w\.\-\d\?&=\/]*)(?:<em .*?>(.*?)<\/em>)?)(?:<\/em>)?([\w\.\-\d\?&=\/]*)?/g, '<a target="_blank" href="$1$2$3">$&</a>')

  getSortedEvidencesBy: (field) ->
    return _.sortBy(_.groupBy(_.filter((@get('evidences') || []), (evidence) -> evidence.field == field), 'start'), (val, key, evidence) ->  key * -1)

  enhancedContent: ->
    @getContentEnhancer().getContent()

  getContentEnhancer: (text=null) =>
    return new Monitoring.Models.ContentEnhancer(this, text)

  isFacebook: ->
    return false

  hasContentUrl: -> @contentUrl() if @contentUrl

  getMedias: ->
    []

  isPublished: ->
    false

  isHidden: ->
    false

  canPlayVideoType: (type) ->  #This method is used because Mozilla Firefox has trouble playing mp4 videos, and twitter uses this format for gifs
    !!document.createElement('video').canPlayType(type)

  hasContext: ->
    try
      if @getRootParentId() then true else false
    catch
      false

  isResponseFromClient: ->
    @get('is_response_from_client') || false

  isBrandContent: ->
    content = @get('data')['content']
    page_owner_generated = content != undefined && content['page_owner_generated'] == 'true'
    page_owner_generated || @isResponseFromClient()


  hasProfile: ->
    true

  inResponseTo: ->
    @get('data').content['in_response_to']

  interaction: ->
    return @attributes.social_users[0]

  type: ->
    return @interaction().source

  userId: ->
    return @interaction().social_network_id

  name: ->
    return @interaction().values.name

  gender: ->
    return @interaction().values.gender || 'unknown'

  location: ->
    return @interaction().values.location || 'Unrecognized'

  avatar: ->
    return @interaction().values.avatar

  userLink: ->
    return @interaction().values.link

  created_at: ->
    return @attributes.profile.created_at

  updated_at: ->
    return @attributes.profile.updated_at

  tickets_count: ->
    return @attributes.profile.tickets_count

  contents_count: ->
    return @attributes.profile.contents_count

  link: ->
    @userLink()

  username: ->
    @interaction().values.username

  contentUrl: ->
    ''

  isPublished: ->
    false

  isHidden: ->
    false

  otherNetworks: ->
    return @attributes.social_users

  getSocialNetworkName: (type) ->
    return 'facebook' if /(FBPost|FBComment|FBMessage)/.test(type)
    return 'instagram' if /instagram/.test(type)
    return 'disqus' if /(disqus|TMZ|TooFab)/i.test(type)
    return 'livefyre' if /(Livefyre)/i.test(type)
    type

  socialNetworkName: ->
    @getSocialNetworkName( @type() )

# class Profiling.Collections.ProfilePreviewCollection extends Backbone.Collection
#   model: Profiling.Models.ProfilePreview
#   url: '/profile_preview'
